
    import { defineAsyncComponent } from '#imports'
    
import BlokkliComponent_from_library_index from '/app/node_modules/@blokkli/editor/dist/runtime/components/Blocks/FromLibrary/index.vue'
import BlokkliComponent_anchor_index from '/app/components/Paragraph/Anchor/index.vue'
import BlokkliComponent_anchor_content_index from '/app/components/Paragraph/AnchorContent/index.vue'
import BlokkliComponent_big_picture_index from '/app/components/Paragraph/BigPicutre/index.vue'
import BlokkliComponent_apprenticeships_listing_index from '/app/components/Paragraph/ApprenticeshipsListing/index.vue'
import BlokkliComponent_career_worlds_teaser_index from '/app/components/Paragraph/CareerWorlds/index.vue'
import BlokkliComponent_competencies_services_listing_index from '/app/components/Paragraph/CompetenciesServicesListing/index.vue'
import BlokkliComponent_competencies_listing_manual_index from '/app/components/Paragraph/CompetenciesListingManual/index.vue'
import BlokkliComponent_contact_form_index from '/app/components/Paragraph/Contact/index.vue'
import BlokkliComponent_disruptor_1_col_titlebar_index from '/app/components/Paragraph/Disruptor1ColTitlebar/index.vue'
import BlokkliComponent_downloads_2_col_titlebar_index from '/app/components/Paragraph/Downloads2ColTitlebar/index.vue'
import BlokkliComponent_downloads_listing_category_index from '/app/components/Paragraph/DownloadsListingCategory/index.vue'
import BlokkliComponent_downloads_listing_index from '/app/components/Paragraph/DownloadsListing/index.vue'
import BlokkliComponent_find_a_contact_person_index from '/app/components/Paragraph/FindAContactPerson/index.vue'
import BlokkliComponent_hero_home_index from '/app/components/Paragraph/HeroHome/index.vue'
import BlokkliComponent_hero_text_standard_index from '/app/components/Paragraph/HeroTextStandard/index.vue'
import BlokkliComponent_icon_teaser_3_col_index from '/app/components/Paragraph/IconTeaser3Col/index.vue'
import BlokkliComponent_icon_teaser_2_col_titlebar_index from '/app/components/Paragraph/IconTeaser2ColTitlebar/index.vue'
import BlokkliComponent_icon_text_2_col_titlebar_index from '/app/components/Paragraph/IconText2ColTitlebar/index.vue'
import BlokkliComponent_icon_text_3_col_tabs_index from '/app/components/Paragraph/IconText3ColTabs/index.vue'
import BlokkliComponent_icon_text_3_col_index from '/app/components/Paragraph/IconText3Col/index.vue'
import BlokkliComponent_iframe_standard_index from '/app/components/Paragraph/IframeStandard/index.vue'
import BlokkliComponent_iframe_tabs_index from '/app/components/Paragraph/IframeTabs/index.vue'
import BlokkliComponent_icon_text_2_col_titlebar_tabs_index from '/app/components/Paragraph/IconText2ColTitlebarTabs/index.vue'
import BlokkliComponent_image_fall_off_index from '/app/components/Paragraph/ImageFallOff/index.vue'
import BlokkliComponent_image_fall_off_stripe_index from '/app/components/Paragraph/ImageFallOffStripe/index.vue'
import BlokkliComponent_image_slider_fall_off_left_index from '/app/components/Paragraph/ImageSliderFallOffLeft/index.vue'
import BlokkliComponent_image_svg_index from '/app/components/Paragraph/ImageSvg/index.vue'
import BlokkliComponent_learner_teaser_index from '/app/components/Paragraph/LearnerTeaser/index.vue'
import BlokkliComponent_location_contact_data_index from '/app/components/Paragraph/LocationContactData/index.vue'
import BlokkliComponent_location_route_index from '/app/components/Paragraph/LocationRoute/index.vue'
import BlokkliComponent_locations_overview_index from '/app/components/Paragraph/LocationsOverview/index.vue'
import BlokkliComponent_navigation_breadcrumb_teaser_index from '/app/components/Paragraph/NavigationBreadcrumbTeaser/index.vue'
import BlokkliComponent_navigation_tabs_teaser_index from '/app/components/Paragraph/NavigationTabsTeaser/index.vue'
import BlokkliComponent_news_listing_automatically_index from '/app/components/Paragraph/NewsListingAutomatically/index.vue'
import BlokkliComponent_logos_slider_index from '/app/components/Paragraph/LogoSlider/index.vue'
import BlokkliComponent_news_teaser_automatically_index from '/app/components/Paragraph/NewsTeaserAutomatically/index.vue'
import BlokkliComponent_number_3_col_index from '/app/components/Paragraph/Number3Col/index.vue'
import BlokkliComponent_quotes_slider_index from '/app/components/Paragraph/QuotesSlider/index.vue'
import BlokkliComponent_references_listing_index from '/app/components/Paragraph/ReferencesListing/index.vue'
import BlokkliComponent_scrollytelling_index from '/app/components/Paragraph/Scrollytelling/index.vue'
import BlokkliComponent_references_swiper_index from '/app/components/Paragraph/ReferencesSwiper/index.vue'
import BlokkliComponent_references_slider_index from '/app/components/Paragraph/ReferencesSlider/index.vue'
import BlokkliComponent_team_contact_col_stripe_index from '/app/components/Paragraph/TeamContactColStripe/index.vue'
import BlokkliComponent_team_listing_categories_index from '/app/components/Paragraph/TeamListingCategories/index.vue'
import BlokkliComponent_team_listing_categories_popup_index from '/app/components/Paragraph/TeamListingCategoriesPopup/index.vue'
import BlokkliComponent_team_listing_locations_index from '/app/components/Paragraph/TeamListingLocations/index.vue'
import BlokkliComponent_team_slider_categories_index from '/app/components/Paragraph/TeamSliderCategories/index.vue'
import BlokkliComponent_teaser_2_col_text_image_index from '/app/components/Paragraph/Teaser2ColTextImage/index.vue'
import BlokkliComponent_teaser_3_col_lg_index from '/app/components/Paragraph/Teaser3ColLarge/index.vue'
import BlokkliComponent_text_1_col_standard_index from '/app/components/Paragraph/Text1ColStandard/index.vue'
import BlokkliComponent_text_1_col_stripe_index from '/app/components/Paragraph/Text1ColStripe/index.vue'
import BlokkliComponent_text_1_col_titlebar_index from '/app/components/Paragraph/Text1ColTitlebar/index.vue'
import BlokkliComponent_text_2_col_scrollnavigation_index from '/app/components/Paragraph/Text2ColScrollnavigation/index.vue'
import BlokkliComponent_text_2_col_standard_index from '/app/components/Paragraph/Text2ColStandard/index.vue'
import BlokkliComponent_text_2_col_titlebar_index from '/app/components/Paragraph/Text2ColTitlebar/index.vue'
import BlokkliComponent_text_3_col_standard_index from '/app/components/Paragraph/Text3ColStandard/index.vue'
import BlokkliComponent_text_image_2_col_bg_color_index from '/app/components/Paragraph/TextImage2ColBgColor/index.vue'
import BlokkliComponent_text_image_2_col_bg_color_text_index from '/app/components/Paragraph/TextImage2ColBgColorText/index.vue'
import BlokkliComponent_text_image_2_col_special_index from '/app/components/Paragraph/TextImage2ColSpecial/index.vue'
import BlokkliComponent_text_image_2_col_standard_index from '/app/components/Paragraph/TextImage2ColStandard/index.vue'
import BlokkliComponent_text_number_2_col_titlebar_index from '/app/components/Paragraph/TextNumber2ColTitlebar/index.vue'
import BlokkliComponent_text_indented_stripe_index from '/app/components/Paragraph/TextIndentedStripe/index.vue'
import BlokkliComponent_hero_video_slider_index from '/app/components/Paragraph/VideoSlider/index.vue'
import BlokkliComponent_text_number_3_col_index from '/app/components/Paragraph/TextNumber3Col/index.vue'
import BlokkliComponent_blokkli_fragment_index from '/app/node_modules/@blokkli/editor/dist/runtime/components/Blocks/Fragment/index.vue'
import BlokkliComponent_video_content_width_index from '/app/components/Paragraph/VideoContentWidth/index.vue'

const global: Record<string, any> = {
  block_from_library: BlokkliComponent_from_library_index,
  block_anchor: BlokkliComponent_anchor_index,
  block_anchor_content: BlokkliComponent_anchor_content_index,
  block_big_picture: BlokkliComponent_big_picture_index,
  block_apprenticeships_listing: BlokkliComponent_apprenticeships_listing_index,
  block_career_worlds_teaser: BlokkliComponent_career_worlds_teaser_index,
  block_competencies_services_listing: BlokkliComponent_competencies_services_listing_index,
  block_competencies_listing_manual: BlokkliComponent_competencies_listing_manual_index,
  block_contact_form: BlokkliComponent_contact_form_index,
  block_disruptor_1_col_titlebar: BlokkliComponent_disruptor_1_col_titlebar_index,
  block_downloads_2_col_titlebar: BlokkliComponent_downloads_2_col_titlebar_index,
  block_downloads_listing_category: BlokkliComponent_downloads_listing_category_index,
  block_downloads_listing: BlokkliComponent_downloads_listing_index,
  block_find_a_contact_person: BlokkliComponent_find_a_contact_person_index,
  block_hero_home: BlokkliComponent_hero_home_index,
  block_hero_text_standard: BlokkliComponent_hero_text_standard_index,
  block_icon_teaser_3_col: BlokkliComponent_icon_teaser_3_col_index,
  block_icon_teaser_2_col_titlebar: BlokkliComponent_icon_teaser_2_col_titlebar_index,
  block_icon_text_2_col_titlebar: BlokkliComponent_icon_text_2_col_titlebar_index,
  block_icon_text_3_col_tabs: BlokkliComponent_icon_text_3_col_tabs_index,
  block_icon_text_3_col: BlokkliComponent_icon_text_3_col_index,
  block_iframe_standard: BlokkliComponent_iframe_standard_index,
  block_iframe_tabs: BlokkliComponent_iframe_tabs_index,
  block_icon_text_2_col_titlebar_tabs: BlokkliComponent_icon_text_2_col_titlebar_tabs_index,
  block_image_fall_off: BlokkliComponent_image_fall_off_index,
  block_image_fall_off_stripe: BlokkliComponent_image_fall_off_stripe_index,
  block_image_slider_fall_off_left: BlokkliComponent_image_slider_fall_off_left_index,
  block_image_svg: BlokkliComponent_image_svg_index,
  block_learner_teaser: BlokkliComponent_learner_teaser_index,
  block_location_contact_data: BlokkliComponent_location_contact_data_index,
  block_location_route: BlokkliComponent_location_route_index,
  block_locations_overview: BlokkliComponent_locations_overview_index,
  block_navigation_breadcrumb_teaser: BlokkliComponent_navigation_breadcrumb_teaser_index,
  block_navigation_tabs_teaser: BlokkliComponent_navigation_tabs_teaser_index,
  block_news_listing_automatically: BlokkliComponent_news_listing_automatically_index,
  block_logos_slider: BlokkliComponent_logos_slider_index,
  block_news_teaser_automatically: BlokkliComponent_news_teaser_automatically_index,
  block_number_3_col: BlokkliComponent_number_3_col_index,
  block_quotes_slider: BlokkliComponent_quotes_slider_index,
  block_references_listing: BlokkliComponent_references_listing_index,
  block_scrollytelling: BlokkliComponent_scrollytelling_index,
  block_references_swiper: BlokkliComponent_references_swiper_index,
  block_references_slider: BlokkliComponent_references_slider_index,
  block_team_contact_col_stripe: BlokkliComponent_team_contact_col_stripe_index,
  block_team_listing_categories: BlokkliComponent_team_listing_categories_index,
  block_team_listing_categories_popup: BlokkliComponent_team_listing_categories_popup_index,
  block_team_listing_locations: BlokkliComponent_team_listing_locations_index,
  block_team_slider_categories: BlokkliComponent_team_slider_categories_index,
  block_teaser_2_col_text_image: BlokkliComponent_teaser_2_col_text_image_index,
  block_teaser_3_col_lg: BlokkliComponent_teaser_3_col_lg_index,
  block_text_1_col_standard: BlokkliComponent_text_1_col_standard_index,
  block_text_1_col_stripe: BlokkliComponent_text_1_col_stripe_index,
  block_text_1_col_titlebar: BlokkliComponent_text_1_col_titlebar_index,
  block_text_2_col_scrollnavigation: BlokkliComponent_text_2_col_scrollnavigation_index,
  block_text_2_col_standard: BlokkliComponent_text_2_col_standard_index,
  block_text_2_col_titlebar: BlokkliComponent_text_2_col_titlebar_index,
  block_text_3_col_standard: BlokkliComponent_text_3_col_standard_index,
  block_text_image_2_col_bg_color: BlokkliComponent_text_image_2_col_bg_color_index,
  block_text_image_2_col_bg_color_text: BlokkliComponent_text_image_2_col_bg_color_text_index,
  block_text_image_2_col_special: BlokkliComponent_text_image_2_col_special_index,
  block_text_image_2_col_standard: BlokkliComponent_text_image_2_col_standard_index,
  block_text_number_2_col_titlebar: BlokkliComponent_text_number_2_col_titlebar_index,
  block_text_indented_stripe: BlokkliComponent_text_indented_stripe_index,
  block_hero_video_slider: BlokkliComponent_hero_video_slider_index,
  block_text_number_3_col: BlokkliComponent_text_number_3_col_index,
  block_blokkli_fragment: BlokkliComponent_blokkli_fragment_index,
  block_video_content_width: BlokkliComponent_video_content_width_index
}

    


const globalFragments: Record<string, any> = {
  
}


const chunks: Record<string, () => Promise<any>> = {
  rare: () => import('#blokkli/chunk-rare')
}

const chunkMapping: Record<string, string> = {}

const fragmentChunkMapping: Record<string, string> = {}

export function getBlokkliItemComponent(bundle: string, fieldListType?: string, parentBundle?: string): any {
  const forFieldListType = 'block_' + bundle + '__field_list_type_' + fieldListType
  if (global[forFieldListType]) {
    return global[forFieldListType]
  }
  if (parentBundle) {
    const forParentBundle = 'block_' + bundle + '__parent_block_' + parentBundle
    if (global[forParentBundle]) {
      return global[forParentBundle]
    }
  }
  const key = 'block_' + bundle
  if (global[key]) {
    return global[key]
  }
  const chunkName = chunkMapping[key]
  if (chunkName) {
    return defineAsyncComponent(() => chunks[chunkName]().then(chunk => {
      return chunk.default[key]
    }))
  }
}

export function getBlokkliFragmentComponent(name: string): any {
  const key = 'fragment_' + name
  if (globalFragments[key]) {
    return globalFragments[key]
  }
  const chunkName = fragmentChunkMapping[key]
  if (chunkName) {
    return defineAsyncComponent(() => chunks[chunkName]().then(chunk => {
      return chunk.default[key]
    }))
  }
}
